import React from 'react';
import PropTypes from 'prop-types';
import Link from '../Link';
import Style from '../Style';
import { P2 } from '../Typography';

class SecondaryAction extends React.PureComponent {
  static propTypes = {
    prefix: PropTypes.element,
  };
  static defaultProps = {
    prefix: 'or, ',
  };

  render() {
    const { prefix, children, ...otherProps } = this.props;

    return (
      <P2
        style={{
          marginTop: '1rem',
          textAlign: 'center',
          color: Style.Colors.shadow2,
          fontStyle: 'italic',
        }}
      >
        {prefix}
        <Link {...otherProps}>{children}</Link>
      </P2>
    );
  }
}

export default SecondaryAction;



// WEBPACK FOOTER //
// ./src/components/SecondaryAction/SecondaryAction.js